import { memo } from "react";

import classNames from "classnames";

import { DefaultCell } from "app/components/React/Table/cells";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { translate } from "app/filters/i18nFilter";

import { CellContainer, ColorContainer } from "./styles";

interface DataWithChartColorCellSchema extends ITableCellProps {
    primary: string;
}

export const DataWithChartColorCell = memo((props: DataWithChartColorCellSchema) => {
    const {
        row: { color, isPrimary },
        value,
    } = props;

    const primaryValue = isPrimary ? `${value} (${translate("common.you")})` : value;

    return (
        <CellContainer>
            <ColorContainer color={color} />
            <DefaultCell
                {...props}
                value={primaryValue}
                className={classNames(isPrimary && "bold")}
            />
        </CellContainer>
    );
});

DataWithChartColorCell.displayName = "DataWithChartColorCell";
